import { Injectable, inject } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { ReportGroupFilterListingService } from 'src/app/services/api/report-group-filter/report-group-filter-listing.service';
import { Applicable } from 'src/app/pages/administration/report-groups/report-groups.types';
import {
  FilterModel,
  FilterModels,
  ListingFiltersSource
} from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import {
  FIELD_OPERATIONS_SENSORS_DATE_TIME,
  FIELD_OPERATIONS_SENSORS_REASON
} from './field-operations-sensors-listing.filters';

@Injectable()
export class FieldOperationsSensorsListingFiltersSourceService implements ListingFiltersSource {
  readonly reportGroupFilterService = inject(ReportGroupFilterListingService);

  readonly #applicable = Applicable.AmiHealthDashboard;

  getAll(): Observable<FilterModels> {
    return this.getReportGroup().pipe(
      map(reportGroupFilter => [
        FIELD_OPERATIONS_SENSORS_DATE_TIME,
        reportGroupFilter,
        FIELD_OPERATIONS_SENSORS_REASON
      ]),
      catchError(error => {
        console.error(error);
        return of([]);
      })
    );
  }

  getReportGroup(): Observable<FilterModel> {
    return this.reportGroupFilterService.getFilter(this.#applicable);
  }
}
